const $lookbook = ($('#lookbookCaptionCarousel'), $('#lookbookCarousel'));
if ($lookbook.length){
$lookbook.owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    navspeed: 1500,
    items: 1,
});
}

const $caption = $('#lookbookCaptionCarousel');
if ($caption.length){
$caption.owlCarousel({
  loop: true,
  // autoplay: true,
  autoplayTimeout: 7000,
  autoplayHoverPause: false,
  autoplaySpeed: 500,
  navSpeed: 500,
  nav: true,
  dots: false,
  items: 1,
  mouseDrag: false,
  touchDrag: false,
})
$('.owl-next').click(function() {
    $caption.trigger('next.owl.carousel', [1500]);
    $lookbook.trigger('next.owl.carousel', [500]);
})
$('.owl-prev').click(function() {
    $caption.trigger('prev.owl.carousel', [1500]);
    $lookbook.trigger('prev.owl.carousel', [500]);
})
// $caption.on("change.owl.carousel", function (e) { //When a property is going to change its value.
//  $lookbook.trigger("to.owl.carousel", [e.item.index--, 1500]); //Goes to position.
// });
}

const $lookbookMob = $('#lookbookMobCarousel');
if ($lookbookMob.length) {
  $('#lookbookMobCarousel').owlCarousel({
      loop: true,
      animatedOut: 'fadeOut',
      // autoplay: true,
      autoHeight: true,
      autoplaySpeed: 500,
      navSpeed: 500,
      items: 1,
  });
}